module.exports = __webpack_public_path__ + "img/HuaweiY6.be4e2cff.png";